import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, initializeFirestore, Firestore, enableNetwork } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';
import { getAnalytics, Analytics } from 'firebase/analytics';
import { getFunctions, Functions } from 'firebase/functions';
import { config } from '../config/appConfig';

// Initialize Firebase
let app: FirebaseApp;
let auth: Auth;
let db: Firestore;
let storage: FirebaseStorage;
let functions: Functions;
let analytics: Analytics | null = null;

try {
  app = initializeApp(config.firebase);
  
  // Initialize services with error handling
  // Skip Auth initialization for Node.js scripts
  if (typeof window !== 'undefined') {
    try {
      auth = getAuth(app);
    } catch (authError) {
      console.warn('Firebase Auth initialization failed:', authError);
      auth = null as any;
    }
  } else {
    // Running in Node.js environment - skip Auth
    auth = null as any;
    console.log('Skipping Firebase Auth initialization in Node.js environment');
  }
  
  // In Node.js the default gRPC transport is unreliable and silently drops to
  // offline mode (queries then return empty snapshots from cache). Force long
  // polling there; browsers keep the default transport.
  db = typeof window === 'undefined'
    ? initializeFirestore(app, { experimentalForceLongPolling: true })
    : getFirestore(app);

  if (typeof window === 'undefined') {
    try {
      enableNetwork(db).catch((err) => {
        console.warn('Could not enable Firestore network:', err);
      });
    } catch (err) {
      console.warn('Firestore network configuration warning:', err);
    }
  }
  
  storage = getStorage(app);

  // Callables are deployed to us-central1 (see functions/src/index.ts).
  functions = getFunctions(app, 'us-central1');
  
  // Initialize Analytics only in production and if measurement ID is provided
  if (config.environment === 'production' && config.firebase.measurementId && typeof window !== 'undefined') {
    try {
      analytics = getAnalytics(app);
    } catch (analyticsError) {
      console.warn('Firebase Analytics initialization failed:', analyticsError);
      analytics = null;
    }
  }
} catch (error) {
  console.error('Firebase initialization error:', error);
  throw new Error('Failed to initialize Firebase. Please check your configuration.');
}

export { auth, db, storage, functions, analytics };
export default app;
